import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { omit } from 'lodash';
import { createQueryKey, useAxiosClient, useMutation, useQueryClient } from '@lumahealthhq/ui-model';
import { useLogger } from '@lumahealthhq/ui-utils';
export default function useUpdateOne(variant, basePath, options) {
  var axiosClient = useAxiosClient();
  var queryClient = useQueryClient();
  var logger = useLogger();
  function mutationFn(_x) {
    return _mutationFn.apply(this, arguments);
  }
  function _mutationFn() {
    _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(variables) {
      var url, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = variant.replace('{basePath}', basePath).replace('{id}', variables._id);
            _context.next = 3;
            return axiosClient.put(url,
            // Omitting the _id to avoid errors of BE not accepting it for some PUT requests
            omit(variables, ['_id']));
          case 3:
            response = _context.sent;
            // Invalidate queries that depend on this `id`
            queryClient.invalidateQueries(variables._id)["catch"](logger.warn);
            return _context.abrupt("return", response.data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _mutationFn.apply(this, arguments);
  }
  var mutationKey = createQueryKey(basePath, variant);
  return useMutation(mutationKey, mutationFn, options);
}